import React, {useState} from 'react';
import ShadButtonBasic from "../buttons/ShadButonBasic";

function CodeCreateInput({title, creator}) {

    const [value, setValue]=useState("")
    const [inputOpen, setInputOpen]=useState(false)

    return (
        <>
        <div className="mt-1 relative">
            {inputOpen &&
                <input
                    type={"text"}
                    className={`basic-input focus w-full absolute top-[-8px] border-blue-i`}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            creator(value)
                    }}}
                    maxLength={255}
                />
            }
        </div>
        <div className="ml-auto mb-2">
            {/* + 버튼 */}
            <ShadButtonBasic
                text={inputOpen ? "↑": title? title : "그룹을 생성하려면 클릭하세요" } variant={""}
                className={"w-full h-[30px] mt-[2rem]  code-btn"}
                onClick={()=>setInputOpen(!inputOpen)}
            />
        </div>
        </>
    );
}

export default CodeCreateInput;